import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Circle } from '../..';
import constants from '../../../../core/constants';
import DateHelpers from '../../../../core/helpers/DateHelper';

const ClockLineDay = styled.div.attrs((pr: any) => ({
  passedDays: pr.passedDays
}))`
  &:before {
    content: '';
    border-top-width: 1px;
    border-top-color: var(--text-primary);
    border-top-style: dashed;
    position: absolute;
    width: ${(p) => (p.passedDays !== -1 ? p.passedDays * 100 : 6 * 100)}%;
    right: 100%;
  }

  u {
    position: absolute;
    top: -3px;
    left: -3px;
  }
  width: 100%;
  border-top-width: 1px;
  border-top-color: var(--text-primary);
  border-top-style: solid;
  position: relative;
  overflow: visible;
  @media (max-width: 768px) {
    &:before {
      content: '';
      display: none;
    }
  }
`;

const ClockLineWrapper = styled.div.attrs((pr: any) => ({
  top: pr.top
}))`
  position: absolute;
  top: ${(p) => p.top}px;
  z-index: 1;
  width: 100%;
  left: 0px;
`;

interface Props {
  startHour: number;
  timer: number;
}

function ClockLine(props: Readonly<Props>) {
  const { startHour, timer } = props;
  const getTop = () => {
    const pixelPerMinute = constants.PIXELS_PER_MIN; // 1.6666; // 0.6666;
    const ct = new Date(Date.now());
    const m = ct.getMinutes();
    const h = ct.getHours();
    const t = ((h - startHour) * 60 + m) * pixelPerMinute;
    return t;
  };

  const [top, setTop] = useState(getTop());

  const MINUTE_MS = 60000 * timer;
  useEffect(() => {
    const interval = setInterval(() => {
      setTop(getTop());
    }, MINUTE_MS);
    return () => clearInterval(interval);
  }, []);

  return (
    <ClockLineWrapper top={top}>
      <ClockLineDay passedDays={DateHelpers.getNowDayNumber()}>
        <Circle color="var(--text-primary)" />
      </ClockLineDay>
    </ClockLineWrapper>
  );
}

export default ClockLine;
